'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiFormControl, {
  type FormControlTypeMap as MuiFormControlTypeMap,
} from '@mui/material/FormControl';

type ExcludedMuiProps = '';

type CustomProps = {
  component?: ElementType;
};

type FormLabelTypeMap<
  P = CustomProps,
  D extends ElementType = MuiFormControlTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiFormControlTypeMap['props'], ExcludedMuiProps> & P;
};

export type FormControlProps<
  D extends ElementType = MuiFormControlTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiFormControlTypeMap<P, D>, D>;

const FormControlComponent = (
  props: FormControlProps,
  ref: Ref<HTMLDivElement>
) => {
  return <MuiFormControl {...props} ref={ref} />;
};

FormControlComponent.displayName = 'FormControl';

export const FormControl = forwardRef(
  FormControlComponent
) as OverridableComponent<FormLabelTypeMap>;
